import { useIsPaywallsModalsV3 } from "@/react/hooks/useIsPaywallsModalsV3";
import { PostPurchaseTabV1 } from "./PostPurchaseTabV1";
import { PostPurchaseTabV2 } from "./PostPurchaseTabV2";

interface PostPurchaseTabProps {
  setActiveTab: (tab: string) => void;
  shouldDisplayWorkflowsTab: boolean;
}

export const PostPurchaseTab = (props: PostPurchaseTabProps) => {
  const isPaywallsModalsV3 = useIsPaywallsModalsV3();

  if (!isPaywallsModalsV3) {
    return <PostPurchaseTabV1 {...props} />;
  }

  return <PostPurchaseTabV2 {...props} />;
};
